export default defineNuxtPlugin(() => {
  const env = import.meta.env.VITE_API_ENV
  if (env !== 'prod' && env !== 'rc') {
    import('vconsole').then(({ default: VConsole }) => {
      // eslint-disable-next-line no-new
      new VConsole()
    })
  }
})
